<template>
  <Component
    :is="maxSmall ? DrawerHeader : ProfileBanner"
    :title="$t('components.profile.view.header')"
    v-bind="
      maxSmall
        ? {
            leadingAction: {
              icon: 'edit-pen',
              label: $t('components.profile.edit.title'),
              iconOnly: true,
              event: 'editProfile',
            },
            onEditProfile: () => $emit('editProfile'),
          }
        : { user }
    "
    class="bg-primary max-md:rounded-none"
    @profileEdit="$emit('editProfile')"
  />
</template>

<script setup>
import { DrawerHeader } from "@/SharedComponents/Drawer";
import { ProfileBanner } from "@/SharedComponents/Profile/Partials";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["editProfile"]);

defineProps({
  user: { type: Object, required: true },
});
</script>
